// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"a915d3012effb4c9","818":"9d7901cacb74d83a","915":"7cbbb257e3157317"}[chunkId] + ".js";
};